let evolution2 = function(sketch) {
    sketch.shapes2 = [];
    sketch.rows = 10;
    sketch.cols = 10;
    sketch.shapeSize = 15;
    sketch.waveSpeed = 0.1;
    sketch.zoom = -800;  // Adjust the zoom level

    sketch.setup = function() {
        let canvas = sketch.createCanvas(400, 400, sketch.WEBGL);
        canvas.parent('preview2');
        sketch.tokenId = window.tokenId || 1;
        sketch.randomSeed(sketch.tokenId);

        let spacingX = sketch.width / sketch.rows;
        let spacingZ = sketch.height / sketch.cols;
        
        for (let i = 0; i < sketch.rows; i++) {
            for (let j = 0; j < sketch.cols; j++) {
                let x = sketch.map(i, 0, sketch.rows, -sketch.width / 2, sketch.width / 2);
                let z = sketch.map(j, 0, sketch.cols, -sketch.height / 2, sketch.height / 2);
                sketch.shapes2.push(new sketch.Shape2(x, 0, z));
            }
        }

        sketch.camera(0, -sketch.height, sketch.zoom, 0, 0, 0, 0, 0, -1);
    }

    sketch.draw = function() {
        sketch.background(0);
        sketch.orbitControl(4, 4);

        for (let shape of sketch.shapes2) {
            shape.display();
            shape.update();
        }
    }

    sketch.Shape2 = function(x, y, z) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.angle = sketch.random(sketch.TWO_PI);
        this.speed = 0.01;
        this.amplitude = sketch.random(20, 50);
        this.color = sketch.color(sketch.random(255), sketch.random(255), sketch.random(255), 200);

        this.display = function() {
            sketch.push();
            sketch.translate(this.x, this.y, this.z);
            sketch.fill(this.color);
            sketch.noStroke();
            sketch.box(30);
            sketch.pop();
        }

        this.update = function() {
            let distance = sketch.dist(this.x, this.z, 0, 0);
            this.y = sketch.sin((sketch.frameCount * sketch.waveSpeed - distance * 0.01)) * this.amplitude;
        }
    }
}

let myp52 = new p5(evolution2, 'preview2');















